var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "drop-down-list"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.closeAll
    }
  }), _vm._l(_vm.steps, function (step, index) {
    return _c('div', {
      key: index,
      staticClass: "question-container"
    }, [step.text ? _c('h3', [_vm._v(_vm._s(step.text))]) : _vm._e(), step.image ? _c('div', {
      staticClass: "image"
    }, [_c('img', {
      key: step.image,
      attrs: {
        "src": step.image
      }
    })]) : _vm._e(), _c('kwt-basic-dropdown', {
      attrs: {
        "id": index,
        "items": step.dropDownOptions,
        "on-select-item": _vm.handleSelectItem,
        "handle-open": _vm.handleOpen,
        "open-dropdown": _vm.openDropdown
      }
    })], 1);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }